<template lang="pug">
    v-form.c-form(autocomplete="off")
        v-container(fluid grid-list-lg)

            v-layout.align-center(raw wrap)
                v-flex(xs12)

                    // Horizontal line
                    separator-component

                v-flex(xs12 sm6)
                    title-component(title="Program" type="h5")

                v-flex.text-sm-right.pb-3(xs12 sm6)

                    // Date range
                    range-component(
                        :startDateLabel="$t('fields.startDate')"
                        :endDateLabel="$t('fields.endDate')"
                        :startDate="model.definitions.program.startedAt"
                        :endDate="model.definitions.program.endedAt"
                        :rangeCallback="rangeCallback"
                    )

            program-form


            // Meditations draggable list
            // meditations-list

            v-layout.align-center(v-if="!isChallenge" raw wrap)
                v-flex(xs12)

                    // Horizontal line
                    separator-component

                v-flex(xs6)

                    // Emails title
                    title-component(
                        type="h5"
                        :title="$t('programs.create.subtitle')"
                    )

                v-flex(xs6)

                    // Email form Modal window
                    email-component


                v-flex(xs12)

                    emails-list
</template>

<script>
    import VueTypes from 'vue-types';
    import ProgramForm from './ProgramForm';
    import meditationsList from './meditationsList';
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import DateRange from '~components/DateRange';
    import EmailForm from '~components/EmailForm';
    import { mapFields } from 'vuex-map-fields';
    import { mapGetters } from 'vuex';
    import EmailsList from './emailsList';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            EmailsList,
            ProgramForm,
            meditationsList,
            ButtonComponent: Button,
            EmailComponent: EmailForm,
            RangeComponent: DateRange,
            SeparatorComponent: Separator,
            TitleComponent: Title
        },
        props: {
            action: VueTypes.string.def('create')
        },
        computed: {
            ...mapFields('businesses', {
                model: 'business'
            }),
            ...mapFields('programs', ['program']),
            ...mapGetters('businesses', ['isLoading', 'isChallenge']),
            ...mapGetters('sessions', ['sessions']),

            /**
             * Submit button text
             *  @returns {string}
             */
            submitButtonText() {
                if (this.action === 'create') {
                    return this.$t('defaultButtons.save');
                }

                return this.$t('defaultButtons.update');
            }
        },
        methods: {
            rangeCallback(e) {
                this.model.definitions.program.startedAt = e.from;
                this.model.definitions.program.endedAt = e.to;
            }
        }
    };
</script>
